import { Button, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const ListsW = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 40px;

  @media (max-width: 1023px) {
    display: flex;
    overflow-x: auto;
    margin-top: 0px;
  }

  @media (max-width: 1280px) and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ContainerW = styled('div')`
  width: 100%;
  position: relative;
  border-radius: 15px;
  backgroundcolor: #fbfbfb;

  @media (max-width: 1023px) {
    margin-bottom: 32px;
    overflow: hidden;
  }
`;

export const PageHeaderW = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageTitle = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const AddButton = styled(Button)`
  background: ${({ theme }) => theme.palette.info.main};
  color: ${({ theme }) => theme.palette.white.main};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.palette.info.dark};
  }
`;

export const SeeAllLink = styled(NavLink)`
  position: absolute;
  bottom: -24px;
  right: 8px;
  text-align: right;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.p080};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;
